import React, { useEffect } from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import ErrorPage from '../components/common/ErrorPage';
import Review from '../components/review/Review';
import ExtractionBatchHeader from '../components/extractionBatches/ExtractionBatchHeader';
import TableStyles from '../components/documents/Table.module.css';
import TopBar from '../components/common/TopBar';
import errorResponses from '../errorResponses';
import useGlynt from '../components/hooks/useGlynt';
import useSetOrg from '../components/hooks/useSetOrg';
import { AppContext } from '../App';
import { getIdFromUrl } from '../utils/getIdFromUrl';
import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { useSetTitle } from '../components/hooks/useSetTitle';
import { MarkContextProvider } from '../context/MarkContext';
import { ContentWrapper } from '../components/tool/layout/ToolLayout.styles';
// apporach: get resource from id directly, use index of extraction-batches.extractions instead (it exposes all extractions at once)
function ReviewPage() {
  const { dpid, id, eid } = useParams<{
    dpid: string;
    id: string;
    eid: string;
  }>();

  if (!id) {
    throw new Error("Missing 'id' parameter");
  }

  if (!dpid) {
    throw new Error("Missing 'dpid' parameter");
  }

  const { extractionIndex, setExtractionIndex } = React.useContext(AppContext);
  // const [extractionIds, setExtractionIds] = useState<string[]>([]);
  const glynt = useGlynt(dpid);
  const { loading, error } = useSetOrg(dpid);
  const extractionBatchData = useQuery({
    queryKey: ['extractionBatch', id],
    queryFn: async () => (await glynt).extractionBatch.retrieve(id),
    enabled: !loading,
    refetchOnWindowFocus: false
  });

  useSetTitle(
    extractionBatchData.data?.label ? `Review - ${extractionBatchData.data?.label}` : '...'
  );

  // get index from list of urls
  // // FIXME: Move to useEffect
  const extractionIds = extractionBatchData.data?.extractions.map((url) => getIdFromUrl(url)) || [];

  useEffect(() => {
    // FIXME: We need to make sure this isn't causing any side effects.
    if (extractionIds.indexOf(eid) != -1) {
      setExtractionIndex(extractionIds.indexOf(eid));
    }
  }, [extractionBatchData.isSuccess, eid]);

  if (extractionBatchData.isPending || loading) return <LinearProgress />;

  if (error) {
    return <ErrorPage error={errorResponses.invalidDataPool} />;
  } else if (extractionBatchData.isError) {
    return <ErrorPage error={errorResponses.invalidExtractionBatchId} />;
  }

  return (
    <MarkContextProvider>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          overflow: 'hidden',
        }}
      >
        <TopBar />

        {extractionBatchData.data ? (
          <>
            <div
              className={TableStyles.extractionBatchHeaderWrapper}
              style={{
                flex: '0 0 auto',
              }}
            >
              <ExtractionBatchHeader
                extractionBatch={extractionBatchData.data}
                dpid={dpid}
                eid={id}
              />
            </div>
            <div
              className={`reviewViewport`}
              style={{
                flex: '1 1 auto',
                minHeight: 0,
                overflow: 'hidden',
              }}
            >
              <ContentWrapper>
                <Review
                  ebId={extractionBatchData.data.id}
                  dpid={dpid}
                  extractionBatch={extractionBatchData.data}
                  extractionIndex={extractionIndex}
                  extractionIds={extractionIds}
                />
              </ContentWrapper>
            </div>
          </>
        ) : null}
      </div>
    </MarkContextProvider>
  );
}
export default ReviewPage;
